import InputRemarks from '../form/InputRemarks.js';
import React, { useState } from 'react';
import Form from 'react-bootstrap/Form';


function PanelInputRemarks(props) {
 
  //const [isPreview, setPreview] = useState(false);
  //const [images, setImages] = useState([]);
  const [DisabledRemarks, setDisabledRemarks] = useState(false);

  
  const [inputs, setInputs] = useState({
        lang: "",
        lang2: "",
        remark : "",
        remark2 : ""
      });

    const setLang = (event) => {
      var Lang = event.target.value;
      setInputs({...inputs, Lang: Lang});
      props.setLang(event);
      
      const EmptyRemarks = { target: { value: "" } };
      setRemarks(EmptyRemarks);
    };
  
    const setRepeatLang = (event) => {
      var Lang2 = event.target.value;
      setInputs({...inputs, Lang2: Lang2});
      props.setRepeatLang(event);
  
      const EmptyRemarks = { target: { value: "" } };
      setRepeatRemarks(EmptyRemarks);
    };

  const setRemarks = (event) => {
    var remark = event.target.value;
    setInputs({...inputs, remark: remark});
    props.setRemarks(event);
  };

  const setRepeatRemarks = (event) => {
    var remark2 = event.target.value;
    setInputs({...inputs, remark2: remark2});
    props.setRepeatRemarks(event);

  };


   return (
    <div className="step">
      <p>步驟{props.step}：訂製姓氏<br></br>（只接受最多 2個字元的中文姓氏，繁體/簡體亦可。）</p>

        <InputRemarks langList={props.langList} setLang={setLang} setDisabledRemarks={DisabledRemarks} setRemarks={setRemarks} groupName="remarks1" handleClearimage_Generatation_Status={props.handleClearimage_Generatation_Status}></InputRemarks>
        <p>請重覆輸入訂製姓氏</p>
        <InputRemarks langList={props.langList} setLang={setRepeatLang} setDisabledRemarks={DisabledRemarks} setRemarks={setRepeatRemarks} groupName="remarks2" handleClearimage_Generatation_Status={props.handleClearimage_Generatation_Status}></InputRemarks>
        
       { /*{isPreview && (
        <>
        <ModalWithGallery isShowModal={isPreview} setIsShowModal={setPreview} images={images}></ModalWithGallery>
          {/* <div className="modal-overlay">
            <div className="modal-content">
              <button onClick={() => setPreview(false)}>關閉</button>
              <iframe
              id="imageFrame" 
              src="https://d3rjz8ekfvkhzh.cloudfront.net/frontend/api/ImageGeneration/Generate?word=三好&hash=c2cf1a18609c7497eed538befa1454fcaae468467b5b1e25bbb66406769a5817"
              title="預覽效果圖" 
              width="100%" 
              height="500px" 
              frameBorder="0" 
              allowFullScreen
              ></iframe>
              <br></br>
              <button onclick="showPreviousImage()">上一張</button>
              <button onclick="showNextImage()">下一張</button>

            </div>
          </div> 
        </>
        )}*/}
      
      <p className="warning">**提交訂單後不得作任何更改，請確認資料無誤</p>
      <p className="warning" >***確認訂單前，請先預覽印刷效果圖</p>
    </div>
   );
 }

 function PrintRadio(props){
  return <><Form.Check inline="true" type="radio" name={props.groupName} label={props.description} value={props.value} checked={props.checkedValue} onChange={props.handleChangeLanguage}/></>
}
 
export default PanelInputRemarks;